module.exports = __webpack_public_path__ + "static/media/cooling-stering-flush-and-fill.e5cf8b52.svg";